<template>
  <div class="component-tool-ads">
    <h4 class="text-semibold mb-5">{{ title }}</h4>
    <action-dispatcher action="product/get" :parameters="{ limit: 1000 }">
      <snow-select
        v-model="product_id"
        class="product-select mb-5"
        id="product-select"
        label="Nome do produto"
        :options="products.map(({ id, name }) => ({ id, name }))"
      />
    </action-dispatcher>

    <div class="text-center my-9" v-if="loading">
      <b-spinner variant="primary" />
    </div>
    <template v-else-if="product">
      <snow-data-table-header
        @add="modal = true"
        addText="Adicionar integração"
        @searching="search"
        :filters="false"
        :datePicker="false"
      />

      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>

      <div
        v-else-if="!pixelList.length"
        class="container centralize-row text-center pt-9"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/no-content.svg"
            />
            <h5>Você ainda não adicionou um pixel</h5>
            <div class="text-secondary mb-9">
              Clique nos botões acima e adicione o primeiro
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <data-table
          new-design
          class="d-none d-lg-block"
          :data="pixelList"
          :columns="columns"
        >
          <template #default="{ item, i }">
            <span>
              {{ item.type.toUpperCase() }}
            </span>
            <span>
              {{ item.code }}
            </span>
            <span>
              {{ item.conversion_label || "-" }}
            </span>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="actions"
                @edit-pixel="editPixel(item, i)"
                @remove-pixel="submitRemovePixel(i)"
              />
            </div>
          </template>
        </data-table>
        <data-table
          new-design
          class="d-lg-none"
          :data="pixelList"
          :columns="['', '']"
        >
          <template #default="{ item, i }">
            <div class="responsive-table">
              <span>
                <strong>Ferramenta:</strong>
                {{ item.type.toUpperCase() }}
              </span>
              <span>
                <strong>Pixel:</strong>
                {{ item.code }}
              </span>
              <span>
                <strong>Label de Conversão:</strong>
                {{ item.conversion_label || "-" }}
              </span>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="actions"
                @edit-pixel="editPixel(item, i)"
                @remove-pixel="submitRemovePixel(i)"
              />
            </div>
          </template>
        </data-table>
      </div>
      <pixel-modal
        v-if="product && product.pixel"
        v-model="modal"
        :type="pixelType"
        :pixel="editedPixel"
        :customConversionLabel="pixelType === 'google_ads'"
        @submit="submitPixel"
        @submitEdit="submitEditPixel"
      />
    </template>
  </div>
</template>

<script>
import PixelMixin from "@/mixins/pixel";
import { mapState } from "vuex";
export default {
  mixins: [PixelMixin],
  data() {
    return {
      title: "",
      product_id: null
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    breadcrumbs() {
      return [
        {
          title: "Ferramentas",
          link: "tools"
        },
        { title: this.title }
      ];
    },
    pixelList() {
      let list = [];

      if (this.product && this.product.pixel) {
        list = this.product.pixel.filter(p => p.type === this.pixelType);
      }

      if (this.search_text) {
        const res = list.filter(p =>
          JSON.stringify(p)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .match(this.search_text)
        );
        return res;
      }

      return list;
    }
  },
  watch: {
    product_id(v) {
      if (v) {
        this.loading = true;
        this.$store.dispatch("product/getProduct", v).finally(() => {
          this.loading = false;
        });
      }
    }
  },
  mounted() {
    this.$store.commit("product/setProduct", null);
  }
};
</script>
<style lang="scss" scoped>
.product-select {
  max-width: 384px;
}
</style>
